import script from "./RecommendationReasons.vue?vue&type=script&setup=true&lang=js"
export * from "./RecommendationReasons.vue?vue&type=script&setup=true&lang=js"

import "./RecommendationReasons.vue?vue&type=style&index=0&id=08d460e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08d460e1"]])

export default __exports__